import LinkBank from "./linkBank";
import LoadingPopup from "./loading";

const StripePopup = (props) => {
  return (
    <div className="stripe-popup">
      <div className="stripe-popup-container">
        <div className="stripe-popup-content">
          <p className="stripe-popup-content-title">
            Link bank account not supported in your country
          </p>

          <div className="stripe-popup-content-footer-cont">
            <p className="stripe-popup-content-footer">
              NOTE:{" "}
              <span className="stripe-popup-content-footer-label">
                Seems like linking bank account in your country is not supported
                on our platform. But you can always use Stripe and keep your
                account linked there.
              </span>{" "}
            </p>
          </div>
        </div>
        <p
          onClick={() => {
            window.open("https://stripe.com/", "_blank");
          }}
          className="stripe-popup-content-footer-link"
        >
          Know More
        </p>
      </div>

      <div className="stripe-popup-buttons">
        <button
          onClick={() => {
            props.setPopupContent(
              <LinkBank
                setShowPopup={props.setShowPopup}
                setPopupContent={props.setPopupContent}
                setPopupContentPosition={props.setPopupContentPosition}
                currentStep="2"
                generalDataProps={props.generalDataProps}
                countryList={props.countryList}
                buttonAction="link-bank"
              />
            );
            props.setPopupContentPosition("flex-end");
            props.setShowPopup(true);
          }}
          className="verify-kyc-button-back"
        >
          <p className="verify-kyc-button-back-text">Back</p>
        </button>
        <button
          onClick={() => {
            props.setPopupContent(
              <LoadingPopup
                setShowPopup={props.setShowPopup}
                setPopupContent={props.setPopupContent}
                setPopupContentPosition={props.setPopupContentPosition}
                setFavouriteClicked={props.setFavouriteClicked}
                action="stripe-connect"
                isCustom={true}
                customTextHeader="Searching..."
                customTextFooter={`Looking for card linked with your wallet in ${props.countryCode}`}
                countryCode={props.countryCode}
                generalDataProps={props.generalDataProps}
                countryList={props.countryList}
              />
            );
            props.setPopupContentPosition("flex-end");
            props.setShowPopup(true);
          }}
          className="verify-kyc-button"
        >
          <p className="verify-kyc-button-text">Link With Card</p>
        </button>
      </div>
    </div>
  );
};

export default StripePopup;
